/* eslint-disable no-unused-vars */
import React from 'react';
import { Grid, Flex, Box, Icon, Button, Tooltip } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FiSettings, FiMail } from 'react-icons/fi';
import ColorModeSwitcher from '../ColorModeSwitcher';
import { USER_SETTINGS } from 'routes';
import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InstanceInfoAlert from 'components/InstanceInfoAlert';
import { HelpdeskContactButton } from 'HelpdeskContactButton';

const UserSettingsMenu = () => {
  const { t } = useTranslation();
  return (
    <Tooltip label={t('user.settings', 'Panel użytkownika')}>
      <Button
        as={Link}
        to={generatePath(USER_SETTINGS)}
        variant='ghost'
        aria-label={t('user.settings', 'Panel użytkownika')}
      >
        <Icon as={FiSettings} fontSize='lg' />
      </Button>
    </Tooltip>
  );
};

const Header = ({ gridArea }) => {
  return (
    <Grid gridArea={gridArea} w='100%' gap={2} paddingX={6} paddingY={2}>
      <Flex direction='row' alignItems='center' flex='1 1 100%'>
        <Box mx='auto' />

        <InstanceInfoAlert />
        <ColorModeSwitcher />
        <UserSettingsMenu />
        <HelpdeskContactButton />
      </Flex>
    </Grid>
  );
};

Header.propTypes = {
  gridArea: PropTypes.string,
};

export default Header;
